import React from 'react';
import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Snackbar, TextField, Typography } from '@mui/material';
import { useCreateUserForm } from '../hooks/useCreateUserForm';

export default function CreateUserForm() {
  const {
    nombre, setNombre, apellidos, setApellidos, usuario, setUsuario, email, setEmail, password, setPassword, profesional, setProfesional,
    openGood, setOpenGood, openBad, setOpenBad, errors, handleSave,
  } = useCreateUserForm();

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={0} sx={{ mb: 3, p: { xs: 3, md: 4 }, borderRadius: 3, color: '#fff', background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #64b5f6 100%)' }}>
        <Typography variant="h4">Crear usuario</Typography>
      </Paper>
      <Grid container spacing={2}>
        <Grid item xs={6}><TextField label="Nombre" required fullWidth margin="normal" error={!!errors.nombre} helperText={errors.nombre} value={nombre} onChange={(e) => setNombre(e.target.value)} /></Grid>
        <Grid item xs={6}><TextField label="Apellidos" required fullWidth margin="normal" error={!!errors.apellidos} helperText={errors.apellidos} value={apellidos} onChange={(e) => setApellidos(e.target.value)} /></Grid>
        <Grid item xs={6}><TextField label="Usuario" required fullWidth margin="normal" error={!!errors.usuario} helperText={errors.usuario} value={usuario} onChange={(e) => setUsuario(e.target.value)} /></Grid>
        <Grid item xs={6}><TextField label="Email" required fullWidth margin="normal" error={!!errors.email} helperText={errors.email} value={email} onChange={(e) => setEmail(e.target.value)} /></Grid>
        <Grid item xs={6}><TextField label="Contraseña" type="password" required fullWidth margin="normal" error={!!errors.password} helperText={errors.password} value={password} onChange={(e) => setPassword(e.target.value)} /></Grid>
        <Grid item xs={6}>
          <FormControl fullWidth margin="normal">
            <InputLabel>Profesional</InputLabel>
            <Select value={profesional} label="Profesional" onChange={(e) => setProfesional(e.target.value)}>
              <MenuItem value="Enfermero/a">Enfermero/a</MenuItem>
              <MenuItem value="Fisioterapeuta">Fisioterapeuta</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Button variant="contained" color="primary" onClick={handleSave}>Guardar Datos</Button>
      </Box>
      <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}><Alert severity="success" onClose={() => setOpenGood(false)}>Usuario creado correctamente.</Alert></Snackbar>
      <Snackbar open={openBad} autoHideDuration={2000} onClose={() => setOpenBad(false)}><Alert severity="error" onClose={() => setOpenBad(false)}>Revisa los datos del formulario.</Alert></Snackbar>
    </Box>
  );
}
